/* eslint-disable camelcase */
/* eslint-disable no-template-curly-in-string */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import {
  Button, Form, Row, Col, Typography, notification, Grid, Modal,
} from 'antd';
import { api } from '@seaoil/component-lib';

// lib
import { getCurrentEmail, getCurrentUser } from '../../lib/auth';

// specific components for this workflow
import { getRequestObj } from './request';
import validation from './validation';
import EPRHeader from './EPRHeaderSection';
import EPRDetailSection from './EPRDetailSection';

const { useBreakpoint } = Grid;
const { Title } = Typography;
const { mySEAOIL } = api;
const { workflow } = mySEAOIL;
const { initiate } = workflow;

function formatDate(date) {
  const dt = new Date(date);
  const year = dt.getFullYear();
  const month = String(dt.getMonth() + 1).padStart(2, '0');
  const day = dt.getDate();

  return `${year}-${month}-${day}`;
}

// hardcoded company for now
function getCompany(companyCode) {
  switch (companyCode) {
    case '001': // SPI
      return 'SPI';
    case '012': // SFI
      return 'SFI';
    case '002': // OTC
      return 'OTC';
    case '003': // EFTI
      return 'EFTI';
    case '005': // SCI
      return 'SCI';
    case '004': // GUI
      return 'GUI';
    default:
      // code block
      break;
  }
  return null;
}

const defaultStyle = {
  header: {
    paddingTop: '30px',
  },
  title: {
    offset: 8,
    span: 12,
  },
  submitFormItem: {
    textAlign: 'center',
  },
  submitButton: {
    // float: 'center',
    paddingLeft: '30px',
    paddingRight: '30px',
  },
};

const mobileStyle = {
  header: {
    paddingTop: '30px',
    textAlign: 'center',
  },
  title: {
    span: 24,
  },
  submitFormItem: {
    textAlign: 'center',
  },
  submitButton: {
    // float: 'center',
  },
};

export default function ExpensePaymentRequest() {
  const screen = useBreakpoint();
  const [form] = Form.useForm();
  const [style, setStyle] = useState(defaultStyle);
  const [submitting, isSubmitting] = useState(false);
  const [uploading, isUploading] = useState(false);
  const [request, setRequest] = useState(getRequestObj());
  const {
    currency,
    company_code,
    category,
    subcategory_1,
    subcategory_2,
    details,
    total_amount,
    accounting_processors,
  } = request;

  const sanitizeRequest = () => ({
    ...request,
    date_payable: formatDate(request.date_payable),
    billing_period_from: formatDate(request.billing_period_from),
    billing_period_to: formatDate(request.billing_period_to),
    total_amount: Number(total_amount),
    company: getCompany(request.company_code),
    details: details.map((detail) => {
      const sanitizedDetail = { ...detail };
      sanitizedDetail.record_id = sanitizedDetail.key;
      delete sanitizedDetail.key;
      sanitizedDetail.net_amount = Number(sanitizedDetail.net_amount);
      return sanitizedDetail;
    }),
  });

  const clearForm = () => {
    const req = getRequestObj();
    setRequest(req);
    form.resetFields([
      'company',
      'category',
      'subcategory_1',
      'subcategory_2',
      'payee_paygroup',
      'billing_period',
      'payee',
      'project',
      'date_payable',
      'billing_period_from',
      'billing_period_to',
      'cost_center',
      'reference_no',
      'particulars',
      'attachment',
      'mode_of_payment',
    ]);
    form.setFieldsValue({
      billing_period_from: req.billing_period_from,
      billing_period_to: req.billing_period_to,
      date_payable: req.date_payable,
    });
  };

  const handleOnFinish = async () => {
    const currentUser = await getCurrentUser();
    const requested_by = await getCurrentEmail();

    const body = {
      ...sanitizeRequest(request),
      requested_by,
    };

    try {
      await validation(body);
    } catch (e) {
      if (e && e.errors) {
        notification.info({ message: e.errors.join(', ').trim() });
        return;
      }
      notification.info({ message: e.message || e });
      return;
    }

    Modal.confirm({
      title: 'Are you sure you want to submit?',
      content: (
        <div>
          <p>
            You will be submitting this request as&nbsp;
            <strong>{currentUser.name}</strong>
          </p>
          <p>Please click the OK button to submit your request.</p>
          <p>
            {accounting_processors.join(' or ').trim()}
            {' '}
            will handle this request when it reaches the Accounting Department
          </p>
        </div>
      ),
      async onOk() {
        try {
          isSubmitting(true);

          notification.info({ message: 'Submitting your request...' });

          await initiate({
            workflow_name: 'ExpensePaymentRequest',
            data: {
              source_name: 'mySEAOIL UI',
              source_type: 'application/json',
              source_url: window.location.href,
              ...body,
            },
          }).send();

          notification.success({ message: 'Successfully submitted your request.' });
          clearForm();
        } catch (e) {
          notification.error({ message: 'Something went wrong. The system was unable to process your request.' });
        } finally {
          isSubmitting(false);
        }
      },
    });
  };

  useEffect(() => {
    if (screen.xs) {
      setStyle(mobileStyle);
      return;
    }
    setStyle(defaultStyle);
  }, [screen]);

  useEffect(() => {
    form.setFieldsValue({
      billing_period_from: request.billing_period_from,
      billing_period_to: request.billing_period_to,
      date_payable: request.date_payable,
    });
  }, []);

  return (
  <div
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 16,
        padding: '16px 20px',
        borderRadius: 8,
        background: '#fff7e6',
        border: '1px solid #ffd591',
        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.06)',
        maxWidth: 800,
        margin: '16px auto',
        fontFamily:
          "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      }}
    >
      <div
        style={{
          fontSize: 28,
          lineHeight: 1,
          marginTop: 4,
          marginRight: 8,
        }}
      >
        ⚠️
      </div>

      <div style={{ flex: 1 }}>
        <h2
          style={{
            margin: '0 0 8px',
            fontSize: 18,
            fontWeight: 600,
            color: '#ad4e00',
          }}
        >
          Important Notice: New EPR Website
        </h2>

        <p
          style={{
            margin: '4px 0',
            fontSize: 14,
            lineHeight: 1.5,
            color: '#5a5a5a',
          }}
        >
          The current EPR is now <strong>permanently disabled</strong>. Please
          start using the new EPR website for all future requests. We
          recommend updating your bookmarks to avoid any disruption.
        </p>
          <br />
        <p
          style={{
            margin: '4px 0',
            fontSize: 14,
            lineHeight: 1.5,
            color: '#5a5a5a',
          }}
        >
          For any assistance or concerns, please contact itservicedesk@seaoil.com.ph
        </p>
            <br />
        <p
          style={{
            margin: '4px 0 12px',
            fontSize: 14,
            lineHeight: 1.5,
            color: '#5a5a5a',
          }}
        >
          Thank you for your cooperation and continuous support.
        </p>
        <br />
        <center>
          
        <Button
          type="primary"
          href="https://expense.seaoil.com.ph/"
          target="_blank"
          rel="noreferrer" 
          size="large"
        >
          Go to New EPR Website
        </Button>
        </center>
      </div>
    </div>
  )

  return (
    <>
      <Row
        style={style.header}
      >
        <Col
          xs={{ span: 24 }}
          md={{ offset: 8, span: 12 }}
        >
          <Title>Expense Payment Request</Title>
        </Col>
      </Row>
      <div style={{ minHeight: 380 }}>
        <Form
          form={form}
          layout="vertical"
          size="large"
          onFinish={handleOnFinish}
          name="nest-messages"
        >
          <EPRHeader
            disabled={uploading}
            request={request}
            onFileUpload={(uploadInProgress) => {
              isUploading(uploadInProgress);
            }}
            onChange={(newReq) => {
              setRequest((prevReq) => ({
                ...prevReq,
                ...newReq,
              }));
            }}
            onCategoryChange={() => {
              setRequest((prevReq) => ({
                ...prevReq,
                details: prevReq
                  .details
                  .map((detail) => ({
                    ...detail,
                    subcategory_3: '',
                  })),
              }));
            }}
          />
          <EPRDetailSection
            disabled={uploading}
            data={{ currency, details }}
            config={{
              company_code,
              category,
              subcategory_1,
              subcategory_2,
            }}
            onCurrencyChange={(curr) => {
              setRequest(() => ({
                ...request,
                currency: curr,
              }));
            }}
            onTotalAmountChange={(total) => {
              setRequest(() => ({
                ...request,
                total_amount: total,
              }));
            }}
            onDetailsChange={(updatedDetails) => {
              setRequest({
                ...request,
                details: updatedDetails,
              });
            }}
          />
          <Row>
            <Col xs={{ span: 24 }} md={{ span: 24 }}>
              <Form.Item style={style.submitFormItem}>
                <Button
                  style={style.submitButton}
                  block={screen.xs}
                  disabled={uploading || submitting}
                  type="primary"
                  htmlType="submit"
                >
                  {uploading ? 'Wait for upload to finish before submitting' : 'Submit'}
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
}
